import { render, staticRenderFns } from "./EventAvailabilityCard.vue?vue&type=template&id=1a9d0564&scoped=true&"
import script from "./EventAvailabilityCard.vue?vue&type=script&lang=js&"
export * from "./EventAvailabilityCard.vue?vue&type=script&lang=js&"
import style0 from "./EventAvailabilityCard.vue?vue&type=style&index=0&id=1a9d0564&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9d0564",
  null
  
)

export default component.exports